import type { RouteObject } from 'react-router';
import { LeadsPage } from '../leads/LeadsPage';

/** Equipment dealers: the lead table scoped to dealers. Their profiles stay at /leads/:id. */
export const routes: RouteObject[] = [{ path: '/dealers', element: <LeadsPage kind="dealer" /> }];
